// extracted by mini-css-extract-plugin
module.exports = {"even":"statistic_even__OM5UK","title":"statistic_title__3CPjr","odd":"statistic_odd__1vQMm","card-suite":"statistic_card-suite__nSJ8L","red":"statistic_red__2qINK"};